module.exports = __webpack_public_path__ + "static/media/wedding-1.aa611264.mp4";